export default {
  maskBox: (state) => state.commondata.maskBox,
  padWarnShow: (state) => state.commondata.padWarnShow,
  name: (state) => state.commondata.name,
  userType: (state) => state.commondata.userType,
  icodeName: (state) => state.commondata.icodeName,
  isLogin: (state) => state.commondata.isLogin,
  currentUser: (state) => state.commondata.currentUser,
};



// WEBPACK FOOTER //
// ./src/store/getters.js